import React from "react";
import { ReactComponent as SearchIcon } from "assets/common/input/searchIcon.svg";

interface Props {
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  placeholder: string;
}

export function TableSearchInput({ value, setValue, placeholder }: Props) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <div className="flex h-[52px] w-[526px] items-center gap-[12px] rounded-[8px] border-[1px] border-gray-1 bg-white px-[16px] py-[14px] focus-within:border-gray-5">
      <SearchIcon />
      <input
        value={value}
        placeholder={placeholder}
        onChange={handleInputChange}
        className="m-0 w-[90%] border-none bg-white p-0 text-[16px] font-medium leading-[20px] text-gray-5 outline-none placeholder:text-gray-3 focus:ring-0"
      />
    </div>
  );
}
